import { Pill, type PillTone } from './Pill'
import { RECORDING_OUTCOME, type RecordingStatusLike } from '../../lib/recordings'

/**
 * A recording's terminal state, in one place.
 *
 * Not `StatusPill`, which is keyed on the six **account** statuses. A recording
 * has its own eight-value vocabulary and four of them — `pending_upload`,
 * `uploaded`, `queued`, `processing` — are reserved compatibility values with no
 * writer (§2.5). Those render as "unknown state" rather than as progress, and
 * emphatically rather than crashing on a lookup miss: if one ever arrives, it
 * means something changed on the backend and the screen should say it does not
 * recognise the value.
 *
 * The dot plus the label carry the state; the colour is reinforcement, never the
 * information (WCAG 1.4.1), which is the same rule `StatusPill` keeps.
 */
const TONE: Record<string, PillTone> = {
  scored: 'green',
  rejected: 'amber',
  empty: 'neutral',
  failed: 'red',
}

export function RecordingStatusPill({ status }: { status: RecordingStatusLike }) {
  const outcome = RECORDING_OUTCOME[status]
  return (
    <Pill tone={outcome ? TONE[status] ?? 'neutral' : 'neutral'} dot>
      {outcome?.label ?? 'Unknown state'}
    </Pill>
  )
}
